<script setup lang="ts">
import AppShell from '@/components/shell/AppShell.vue'
</script>

<template>
  <AppShell>
    <RouterView />
  </AppShell>
</template>
